module.exports = __webpack_public_path__ + "static/media/Facebook_share.118ed4e7.svg";